import { ContactInfoFields, AppConfigFields } from "../../types/appConfigEntities";

const storeInfoText =
  window.APP_CONFIG?.[AppConfigFields.ContactData]?.[ContactInfoFields.StoreInfo] ||
  "Local Mouchi - Uriburu 384, ONCE // CABA Horario de atencion de lunes a viernes de 9 a 18, sabados de 9 a 13 hs";

export default function StoreInfo() {
  const [main, schedule] = storeInfoText.split("//").map((part) => part.trim());

  return (
    <div
      style={{
        padding: "14px 16px",
        borderRadius: 16,
        background: "rgba(10,10,10,0.03)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 14,
      }}
    >
      <div>
        <div style={{ fontSize: 13, fontWeight: 500 }}>{main || "Local Mouchi · Uriburu 384"}</div>
        <div style={{ fontSize: 11.5, color: "var(--ink-500)", marginTop: 2 }}>
          {schedule || "Lun a Vie 9-18 · Sab 9-13hs"}
        </div>
      </div>
      <span
        style={{
          padding: "6px 12px",
          borderRadius: 999,
          background: "var(--ink-900)",
          color: "var(--cream-50)",
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: "0.08em",
        }}
      >
        GRATIS
      </span>
    </div>
  );
}
